import { FormConfiguration } from "@/modules/GeneralRules/models/FormConfiguration.model";
import { FormInformation } from "@/modules/GeneralRules/models/FormInformationMapped.model";
import { FormOperation } from "@/modules/GeneralRules/models/FormOperation.model";
import { LogicalField } from "@/modules/GeneralRules/models/LogicalField.model";

export const FORM_ACTION_CONSTANTS = {
  LABELS: {
    TABS: {
      INFORMATION: "FUENTE DE INFORMACIÓN",
      OPERATION: "OPERACIONES"
    },
    INFORMATION_HELP:
      "Agregue los formularios y operaciones que requiera para generar la información.",
    OPERATION_HELP:
      "Agregue el tipo de operación y seleccione el campo objetivo para registrar el valor",
    CALCULATOR_HELP:
      "Seleccione la fuente de información que requiere para formular la operación",
    SELECT_GENERATE_TEMPLATE: "Selecciona el formulario a generar",
    SELECT_INFORMATION: "Selecciona la fuente de información",
    INFO_NAME: "Nombre de la fuente",
    SELECT_INFO_TEMPLATE: "Selecciona el formulario de información",
    SELECT_OPERATOR: "Seleccione el operador",
    SELECT_CONNECTOR: "Seleccione el conector",
    VALUE_INPUT: "Ingresa el valor",
    OPERATION: "Operación",
    FROM: "Desde",
    STEP: "Paso",
    GET_FIELD: "Campo a obtener",
    SAME_FIELD_OPERATION: "Operación sobre el campo",
    NO_NUMERIC_FIELDS: "La plantilla elegida no tiene campos numéricos",
    NO_FIELDS: "No se encontraron campos",
    SELECT_OPERATION: "Tipo de operación",
    GET_INFORMATION: "Agregar fuente de información",
    DELETE_INFORMATION: "Eliminar fuente de información",
    ADD_OPERATION: "Agregar operación",
    SAVE_OPERATION: "Guardar operación",
    DELETE_OPERATION: "Eliminar operación",
    OBJ_FIELD: "Campo objetivo",
    CALCULATOR: "Valor del campo objetivo",
    INFO_GET: "Fuente de información"
  },
  SNACKBAR: {
    NO_MORE_OPERATIONS: "No se pueden agregar más operaciones",
    ONLY_ONE_OPERATION: "No puedes seleccionar más de una operación por campo",
    INVALID_OPERATIONS: "Faltan operaciones para campos obligatorios"
  },
  HINT: {
    CALCULATOR:
      "Formule la operación haciendo click en los elementos de la calculadora"
  },
  TOOLTIP: {
    CLEAR: "Limpiar",
    DELETE: "Borrar",
    MULTIPLICATION: "Multiplicar",
    SUBSTRACTION: "Restar",
    ADITION: "Sumar",
    DIVISION: "Dividir"
  },
  EVENTS: {
    CANCEL: "cancelFormAction",
    SAVE: "saveFormAction",
    INFORMATION: {
      ADD: "addFormInformation",
      UPDATE_ARRAY: "updateFormInformation",
      DELETE_FROM_ARRAY: "deleteFormInformation",
      EDIT_ELEMENT: "editElement",
      DELETE_ELEMENT: "deleteElement"
    },
    UPDATE_GENERATION_TEMPLATE: "updateGenerationTemplate",
    OPERATIONS: {
      ADD: "addFormOperation",
      EDIT_OPERATION: "editOperation",
      UPDATE_ARRAY: "updateFormOperation",
      DELETE_FROM_ARRAY: "deleteFormOperation",
      CALCULATOR_UPDATE: "updateCalculator",
      LOGICAL_UPDATE: "updateLogicalOperation",
      ADD_LOGICAL_FIELD: "addLogicalField",
      DELETE_LOGICAL_FIELD: "deleteLogicalField",
      SAVE: "saveOperation",
      DELETE_OPERATION: "deleteOperation"
    },
    LOAD_FORM_TEMPLATES: "loadFormTemplates",
    GET_FORM_TEMPLATES: "getFormTemplates"
  },
  INFO_OPERATION: {
    COUNT: { key: "count", name: "Contar" },
    GET: { key: "get", name: "Obtener" },
    GET_MULTIPLE: { key: "getMultiple", name: "Obtener múltiple" }
  },
  FIELD_OPERATION: {
    LOGIC: { key: "logic", name: "Lógica" },
    ARITHMETIC: { key: "arithmetic", name: "Aritmética" },
    GET_COUNT: { key: "getCount", name: "Obtener" },
    SAME_FIELD: { key: "sameField", name: "En el mismo campo" }
  },
  COMPARATION_OPERATION: {
    MORE_THAN: { key: ">", name: "Mayor que" },
    LESS_THAN: { key: "<", name: "Menor que" },
    MORE_OR_EQUAL: { key: ">=", name: "Mayor o igual que" },
    LESS_OR_EQUAL: { key: "<=", name: "Menor o igual que" },
    EQUAL: { key: "==", name: "Igual" },
    DIFFERENT: { key: "!=", name: "Diferente" }
  },
  LOGIC_CONNECTORS: {
    AND: { key: "and", name: "Y" },
    OR: { key: "or", name: "O" }
  },
  STEP: {
    YEAR: { key: "year", name: "Año" },
    MONTH: { key: "month", name: "Mes" },
    DAY: { key: "day", name: "Día" }
  },
  SAME_FIELD_OPERATORS: {
    ADDITION: { key: "addition", name: "Adición" },
    AVERAGE: { key: "average", name: "Promedio" },
    HIGHER: { key: "higher", name: "Mayor" },
    SMALLER: { key: "smaller", name: "Menor" }
  },
  INFORMATION_KEY: "infokey"
};

export const TABS = {
  INFORMATION: "INFORMATION",
  OPERATION: "OPERATION"
};

export const FORM_ACTION_INIT: FormConfiguration = {
  formName: "",
  formToGenerate: "",
  information: [
    { key: "infokey0", field: "", name: "", formTemplate: "", operation: "" }
  ],
  operations: [
    {
      fieldToSet: "",
      fieldName: "",
      type: "",
      informationKey: "",
      logicalFields: [],
      operation: "",
      value: ""
    }
  ]
};

export const INFORMATION_INIT: FormInformation = {
  key: "",
  field: "",
  name: "",
  formTemplate: "",
  operation: "",
  validElement: false
};

export const OPERATION_INIT: FormOperation = {
  fieldToSet: "",
  fieldName: "",
  type: "",
  informationKey: "",
  logicalFields: [],
  operation: "",
  value: ""
};

export const LOGICAL_FIELD_INIT: LogicalField = {
  key: "",
  operator: "",
  value: ""
};

export const DATA_TYPES = {
  STRING: "string",
  NUMBER: "number",
  ARRAY: "array",
  FORMULA: "formula"
};

export const CALC_OPERATORS = {
  ADDITION: "+",
  SUBSTRACTION: "-",
  MULTIPLICATION: "*",
  DIVISION: "/",
  PARENTHESES_CLOSE: ")",
  PARENTHESES_OPEN: "(",
  BRACKET_OPEN: "{{",
  BRACKET_CLOSE: "}}",
  BRACKET_SIMPLE_OPEN: "{",
  BRACKET_SIMPLE_CLOSE: "}",
  BACKSPACE: "Backspace"
};

export const CALC_ALLOWED_KEYS = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+",
  "-",
  "*",
  "/",
  "(",
  ")",
  "Backspace"
];
